var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationChecking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.5C12 20.5 6 13.5 6 9C6 5.69 8.69 3 12 3C15.31 3 18 5.69 18 9C18 13.5 12 20.5 12 20.5Z",
    stroke: "#D6AF66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 1.65,
    fill: "#D6AF66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationChecking);
export default __webpack_public_path__ + "static/media/location-checking.3cece83f0b95e70b94af8100dd3d9602.svg";
export { ForwardRef as ReactComponent };